/**
 * Where the grant page may send a person once they have answered.
 *
 * NEVER THE LINK'S OWN ADDRESS. `redirect_uri` (ink spells it `return_url`) is
 * chosen by whoever wrote the link, and the page used to assign it straight to
 * `window.location.href` — on the no-click hand-back too, which fires for anyone
 * already holding a grant. `javascript:` there ran script in this origin, where
 * the session tokens live; a foreign host received the person with their user_id
 * and a session code.
 *
 * The preview vets the address against the app's registered callbacks and our own
 * hosts (backend `app/utils/return_url.py`) and returns it as `return_to`, or null.
 * That is the only address this page navigates to.
 *
 * A server too old to send `return_to` gets the narrowest safe reading — an
 * http(s) address or nothing — so the minutes between a frontend deploy and a
 * backend one can never be a script URL.
 */
export function handBackTarget(asked, preview) {
  if (!asked || !preview) return null;
  if (Object.prototype.hasOwnProperty.call(preview, 'return_to')) return preview.return_to || null;
  return isWebAddress(asked) ? asked : null;
}

/** http(s), no userinfo, and nothing a browser rewrites into another host. */
export function isWebAddress(url) {
  // eslint-disable-next-line no-control-regex
  if (typeof url !== 'string' || /[\\\u0000-\u001f\u007f]/.test(url)) return false;
  try {
    const u = new URL(url);
    return (u.protocol === 'http:' || u.protocol === 'https:') && !u.username && !u.password;
  } catch {
    return false;
  }
}
